import { css } from '@emotion/react'
import { typo } from '@mathflat/common/style'

const S = {
  card: css`
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 16px 24px;
    border: 1px solid var(--Colors-Gray-300);
    border-radius: var(--Radius-200);
    background: white;
    ${typo.body02};
    .head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      min-height: 32px;
    }
    .when {
      display: flex;
      align-items: center;
      gap: 4px;
      min-width: 0;
      color: var(--Colors-Gray-900);
    }
    .time {
      flex-shrink: 0;
    }
    .label {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: var(--Colors-Sky-400);
      font-weight: 700;
      &.failed {
        color: var(--Colors-Red-500);
      }
    }
    .worksheet,
    .students {
      color: var(--Colors-Gray-800);
      font-weight: 500;
    }
    .students {
      word-break: break-all;
    }
    &.done {
      .time,
      .worksheet,
      .students {
        color: var(--Colors-Gray-600);
      }
    }
  `,
  expandable: css`
    cursor: pointer;
  `,
}

export default S
